import React from 'react';
export function Footer() {
  return <footer className="bg-clinical-base py-10 md:py-12 border-t border-clinical-line" data-id="element-93">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-8" data-id="element-94">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 mb-8 text-center md:text-left" data-id="element-95">
          <div data-id="element-96">
            <div className="flex items-center gap-2 mb-3 justify-center md:justify-start" data-id="element-97">
              <span className="font-bold text-clinical-deep text-lg tracking-tight uppercase" data-id="element-98">
                Atlas Clínico
              </span>
              <span className="text-clinical-mid font-medium text-xs" data-id="element-99">
                Mega Pack Enfermería
              </span>
            </div>
            <p className="text-clinical-ink/70 text-sm max-w-md mx-auto md:mx-0 mb-2 leading-relaxed" data-id="element-100">
              El sistema clínico digital para estudiantes de enfermería y
              enfermeros/as junior.
            </p>
            <p className="text-clinical-ink/70 text-sm max-w-md mx-auto md:mx-0 leading-relaxed" data-id="element-101">
              Porque{' '}
              <span className="accent-italic" data-id="element-102">
                valorar, registrar y priorizar
              </span>{' '}
              mejor no debería depender solo del tiempo.
            </p>
          </div>

          <div className="md:text-right" data-id="element-103">
            <h4 className="font-bold text-clinical-deep mb-3 text-sm tracking-tight uppercase" data-id="element-104">
              Contacto
            </h4>
            <ul className="space-y-2 text-sm text-clinical-ink/70" data-id="element-105">
              <li className="break-all" data-id="element-106">soportetuvidasimpleok@gmail.com</li>
              <li data-id="element-107">@atlasclinico</li>
              <li data-id="element-108">www.atlasclinico.com</li>
            </ul>
          </div>
        </div>

        <div className="pt-6 border-t border-clinical-line flex flex-col md:flex-row justify-between items-center gap-3" data-id="element-109">
          <p className="text-[11px] md:text-xs text-clinical-ink/50 text-center md:text-left leading-relaxed" data-id="element-110">
            © Atlas Clínico 2026 — Todos los derechos reservados.
          </p>
          <p className="text-sm text-clinical-deep accent-italic text-center md:text-right" data-id="element-111">
            Estudiar mejor también es cuidar mejor.
          </p>
        </div>
      </div>
    </footer>;
}